module.exports = __webpack_public_path__ + "static/media/Bolsa1.91d6483f.jpg";